import AbstractBulkStayStrategyModel from 'uplisting-frontend/models/abstract-bulk-stay-strategy';

export default class BulkRateModel extends AbstractBulkStayStrategyModel {}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'bulk-rate': BulkRateModel;
  }
}
